import { render, staticRenderFns } from "./BankInformationUpdate.vue?vue&type=template&id=f70cbc96&scoped=true"
import script from "./BankInformationUpdate.vue?vue&type=script&lang=js"
export * from "./BankInformationUpdate.vue?vue&type=script&lang=js"
import style0 from "./BankInformationUpdate.vue?vue&type=style&index=0&id=f70cbc96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70cbc96",
  null
  
)

export default component.exports